import moment from 'moment-jalaali';
import { ArrowLeft, X } from 'tabler-icons-react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Names, slugify } from 'Utils';
import { Button } from 'Elements';
import Placeholder from 'assets/img/img-user-default.png';
import styles from 'partials/notification/notif-card.module.scss';

export const NotifCard = ({ card }) => {
	const dismissToast = () => {
		return toast.dismiss(card.id);
	};

	return (
		<article className={styles.box}>
			<header className={styles.header}>
				<h3 className={styles.headerTitle}>
					{+moment().format('jYYYY') -
						+moment.unix(card.start_date).format('jYYYY')}{' '}
					سال پیش در چنین روزی
				</h3>
				<Button className={styles.timer} onClick={dismissToast}>
					<X size="26" />
				</Button>
			</header>
			<div className={styles.body}>
				<Link
					to={`${Names.story.path}/${card.id}/${slugify(card.slug)}`}
					className={styles.imageBox}>
					<img src={card.avatar || Placeholder} alt="" className={styles.image} />
				</Link>
				<div className={styles.content}>
					<h3 className={styles.title}>
						<Link
							to={`${Names.story.path}/${card.id}/${slugify(
								card.slug
							)}`}>
							{card.title}
						</Link>
					</h3>
					<Link
						to={`${Names.story.path}/${card.id}/${slugify(
							card.slug
						)}`}
						className={styles.more}
						role="button"
						tabIndex="0">
						مشاهده روایت{' '}
						<ArrowLeft size="20" className={styles.moreIcon} />
					</Link>
				</div>
			</div>
		</article>
	);
};
